import { render, staticRenderFns } from "./burger-navbar.vue?vue&type=template&id=55253a44&scoped=true&"
import script from "./burger-navbar.ts?vue&type=script&lang=ts&"
export * from "./burger-navbar.ts?vue&type=script&lang=ts&"
import style0 from "./burger-navbar.styl?vue&type=style&index=0&id=55253a44&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55253a44",
  null
  
)

export default component.exports